export default __webpack_public_path__ + "static/media/document_test.fd311698.jpg";